<template>
         <p class="rf-text">Besoin d'aide ? Écrivez-nous : <a href="mailto:pmo.francerelance@modernisation.gouv.fr">pmo.francerelance@modernisation.gouv.fr</a>.</p>
</template>

<script>
    export default {
        name: "infoPlanEtat",
    }
</script>
